import React from 'react'
interface ICustomButtoProps {
    label: string
    type: 'submit' | 'button'
    setShowModal?: () => void
}
export default function CustomButton({
    label,
    type,
    setShowModal,
}: ICustomButtoProps) {
    return (
        <button
            className=" w-full bg-green-1 py-2.5 text-center rounded-lg hover:text-green-1 hover:bg-white border-1 border-green-1 text-white-test transition-colors"
            type={type}
            onClick={setShowModal}
        >
            {label}
        </button>
    )
}
